module.exports = __webpack_public_path__ + "img/list-bank-option.18178829.svg";